import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { IConfirmInitialState } from "./types";

const setConfirm: CaseReducer<IConfirmInitialState, PayloadAction<IConfirmInitialState>> = (state, action) => {
  state.open = action.payload.open;
  state.title = action.payload.title;
  state.description = action.payload.description;
};

export default { setConfirm };